import { render } from "./BrandPoslovniDnevnik.vue?vue&type=template&id=3865dd9f"
import script from "./BrandPoslovniDnevnik.vue?vue&type=script&lang=ts"
export * from "./BrandPoslovniDnevnik.vue?vue&type=script&lang=ts"

import "./BrandPoslovniDnevnik.vue?vue&type=style&index=0&id=3865dd9f&lang=scss"
script.render = render

export default script